import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { Translate, ICrudGetAction } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './pricing.reducer';
import { IPricing } from 'app/shared/model/pricing.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IPricingDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export class PricingDetail extends React.Component<IPricingDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { pricingEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            <Translate contentKey="rtnApp.pricing.detail.title">Pricing</Translate> [<b>{pricingEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="price">
                <Translate contentKey="rtnApp.pricing.price">Price</Translate>
              </span>
            </dt>
            <dd>{pricingEntity.price}</dd>
            <dt>
              <span id="ticketType">
                <Translate contentKey="rtnApp.pricing.ticketType">Ticket Type</Translate>
              </span>
            </dt>
            <dd>{pricingEntity.ticketType}</dd>
            <dt>
              <Translate contentKey="rtnApp.pricing.zone">Zone</Translate>
            </dt>
            <dd>{pricingEntity.zone ? pricingEntity.zone.id : ''}</dd>
            <dt>
              <Translate contentKey="rtnApp.pricing.event">Event</Translate>
            </dt>
            <dd>{pricingEntity.event ? pricingEntity.event.id : ''}</dd>
          </dl>
          <Button tag={Link} to="/entity/pricing" replace color="info">
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>&nbsp;
          <Button tag={Link} to={`/entity/pricing/${pricingEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ pricing }: IRootState) => ({
  pricingEntity: pricing.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PricingDetail);
